import { ampli } from '@/ampli';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { SearchIcon } from '@/ui/Icons/SearchIcon';

import { SEARCH_TREND_QUERY_PARAM } from '@/utils/search-trends';

import { NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID } from '../../../constants/chain';
import { fontStyles } from '../../../styles/typography';
import { TokenBase } from '../../../utils/0x/token-registry.types';
import { SEARCH_TYPES } from '../../../utils/amplitude';
import { routes } from '../../../utils/routes';
import { SearchShortcutKeycap } from '../../SearchShortcutKeycap';

const TokenSelect = dynamic(() =>
  import('../../TransactionModule/components/TokenSelect').then(({ TokenSelect }) => TokenSelect),
);

type Props = {
  position: 'hero' | 'header';
};

export function SearchBar({ position }: Props) {
  const router = useRouter();
  const handleSelectTokenResult = async (token: TokenBase, searchReceiptId?: string) => {
    await router.push({
      pathname: routes.TOKEN_PROFILE,
      query: {
        chainId: NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID[token.chainId],
        contractAddresses: [token.address],
        ...(searchReceiptId ? { [SEARCH_TREND_QUERY_PARAM]: searchReceiptId } : {}),
      },
    });
  };

  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-full max-w-[min(600px,80dvw)] z-[1] my-0 mx-auto top-[105px] tablet:top-[75px]">
      <TokenSelect
        onSelect={handleSelectTokenResult}
        searchType={SEARCH_TYPES.HOME_PAGE}
        isHomepage
      >
        <button
          data-position={position}
          className={fontStyles({
            variant: 'BODY_MD',
            className: [
              'shadow-05',
              'h-10.5',
              'tablet:h-13',
              'absolute',
              'top-0',
              'tablet:text-400',
              'tablet:leading-6',
              // stacking colors
              'bg-[linear-gradient(0deg,var(--color-special-background-button-medium-secondary),var(--color-special-background-button-medium-secondary))]',
              'bg-special-background-app',
              'rounded-2xl',
              'border-0',
              'my-0',
              'mx-auto',
              'text-ellipsis',
              'px-10',
              'relative',
              'w-full',
              'whitespace-nowrap',
              'z-10',
              'max-w-[590px]',
              'has-focus-visible:outline-[3]',
              'has-focus-visible:outline-token-gray-500',
              'has-focus-visible:outline-solid',
            ],
          })}
          aria-keyshortcuts="Meta+K Control+K /"
          onClick={() => ampli.searchFocused({ search_type: 'home_page' })}
        >
          <span className="text-token-gray-800">Search for a token and start trading...</span>
          <SearchIcon className="text-token-gray-1600 h-4 w-4 left-4 pointer-events-none absolute top-3.25 tablet:top-4.5 z-10" />
          <SearchShortcutKeycap className="tablet:flex hidden absolute right-4 z-10 top-3.5" />
        </button>
      </TokenSelect>
    </div>
  );
}
